import { render, staticRenderFns } from "./RegisterSettings.vue?vue&type=template&id=953a6940"
import script from "./RegisterSettings.vue?vue&type=script&lang=js"
export * from "./RegisterSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports